export const layout = {
  labelCol: { span: 10, offset: 0 },
  wrapperCol: { span: 18, offset: 0 },
};
